import { GRAPHQL_POST_QUERIES, GRAPHQL_POST_MUTATIONS } from 'graphql/post'
import type {
  TPostMutationData,
  TPostMutationVariables,
  TPostMutationsName,
  TPostQueriesData,
  TPostQueriesVariables,
  TPostQueriesName,
} from 'graphql/post/types'
import { buildMutationHook, buildQueryHook } from 'lib/apollo-client/builders'

export const usePostMutations = buildMutationHook<TPostMutationsName, TPostMutationVariables, TPostMutationData>(
  GRAPHQL_POST_MUTATIONS
)

export const usePostQueries = buildQueryHook<TPostQueriesName, TPostQueriesVariables, TPostQueriesData>(
  GRAPHQL_POST_QUERIES
)
